<template>
  <div class="wrapper">
    <div class="row">
      <div class="loading-spinner">
        <div class="circle circle-1" />
        <div class="circle circle-2" />
      </div>
    </div>
    <div class="row msg">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.wrapper {
  width: 100vw;
  height: 100vh;
  color: white;
  background: rgba($color-main-darker, 1);
  font-size: 2em;
}

.row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  margin-top: 45vh;
  margin-bottom: 20px;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  position: relative;

  .circle {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: calc(60px / 10) solid transparent;

    &.circle-1 {
      border-top-color: white;
      animation: loading-spinner-animation 1s infinite;
    }

    &.circle-2 {
      border-bottom-color: white;
      animation: loading-spinner-animation 1s infinite alternate;
    }
  }
}

@keyframes loading-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>
